const styleSheet = (theme: any) => ({
  defaultWhite: {
    '&:hover': {
      backgroundColor: 'rgba(46,105,255,0.1)',
    },
    transition: 'background-color 0.5s',
    fontFamily: "'Museo Sans', sans-serif",
    boxSizing: 'border-box',
    height: '40px',
    padding: '0 30px',
    border: '1.8px solid #085FE5',
    borderRadius: '4px',
    color: '#085FE5',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    backgroundColor: '#fff',
    '@media (max-width: 900px)': {
      fontWeight: 'bold',
    },
  },
  defaultClear: {
    '&:hover': {
      backgroundColor: 'rgba(46,105,255,0.1)',
    },
    transition: 'background-color 0.5s',
    fontFamily: "'Museo Sans', sans-serif",
    boxSizing: 'border-box',
    height: '40px',
    padding: '0 30px',
    border: '1.8px solid #085FE5',
    borderRadius: '4px',
    color: '#085FE5',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    backgroundColor: 'transparent',
    '@media (max-width: 900px)': {
      fontWeight: 'bold',
    },
  },
  defaultBlue: {
    '&:hover': {
      backgroundColor: '#0C4CAE',
      border: '1.8px solid #0C4CAE',
    },
    transition: 'background-color 0.5s, border 0.5s',
    fontFamily: "'Museo Sans', sans-serif",
    boxSizing: 'border-box',
    height: (props: any) =>
      (props.overrideStyles && props.overrideStyles.height) || '40px',
    width: (props: any) =>
      (props.overrideStyles && props.overrideStyles.width) || 'auto',
    padding: '0 30px',
    border: '1.8px solid #085FE5',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    backgroundColor: '#085FE5',
    '@media (max-width: 900px)': {
      fontWeight: 'bold',
    },
  },
  defaultRed: {
    '&:hover': {
      backgroundColor: '#c34d4d',
      border: '1.8px solid #c34d4d',
    },
    transition: 'background-color 0.5s, border 0.5s',
    fontFamily: "'Museo Sans', sans-serif",
    boxSizing: 'border-box',
    height: '40px',
    padding: '0 30px',
    border: '1.8px solid #FF6666',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    backgroundColor: '#FF6666',
    '@media (max-width: 900px)': {
      fontWeight: 'bold',
    },
  },
  profile: {
    '&:hover': {
      backgroundColor: '#ECF2FF',
    },
    fontFamily: "'Museo Sans', sans-serif",
    boxSizing: 'border-box',
    height: '40px',
    width: '89px',
    border: '0px solid #FFF',
    boxShadow: '0 2px 6px 0 rgba(0,0,0,0.2)',
    borderRadius: '4px',
    color: '#085FE5',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    backgroundColor: '#fff',
    '@media (max-width: 900px)': {
      fontWeight: 'bold',
    },
  },
  primaryAction: {
    boxSizing: 'border-box',
    height: (props: any) =>
      (props.overrideStyles && props.overrideStyles.height) || '40px',
    width: (props: any) =>
      (props.overrideStyles && props.overrideStyles.width) || '155px',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '18px',
    color: '#FFFFFF',
    borderRadius: '4px',
    backgroundColor: '#0053d2cf',
  },
  secondaryAction: {
    boxSizing: 'border-box',
    height: '36px',
    width: '90px',
    border: '0.5px solid #085FE5',
    color: '#085FE5',
    fontWeight: 500,
    fontSize: '14px',
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  addNew: {
    '&:hover': {
      backgroundColor: '#ECF2FF',
    },
    position: 'relative',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    height: '24px',
    width: '24px',
    border: '1.5px solid #085FE5',
    borderRadius: '4px',
    fontColor: '#085FE5',
    fontWeight: 700,
  },
  goBack: {
    position: 'relative',
    left: '-20px',
    marginBottom: '25px',
    width: '20px',
    border: '0px solid transparent',
    backgroundColor: 'transparent',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  disabledStyle: theme.button.disabled,
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Buttons/DefaultButton/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/components/Buttons/DefaultButton/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }